import backendApi from "@results/services/apiCall/backendApi";

export default class Services {
  static async GetNavigationItems() {
    const path = `/navigation_items`;
    const response = await backendApi.get(path);
    return response.data;
  }
}
